import "core-js/modules/es.array.map.js";
import { Text } from "../../Text/Text/Text";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { SkeletonIndicator } from "../../Indicator/SkeletonIndicator/SkeletonIndicator";
import styles from "./InstructionsFood.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var InstructionsFood = function InstructionsFood(_ref) {
  var headline = _ref.headline,
    instructions = _ref.instructions,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading;
  var renderInstructions = function renderInstructions() {
    return /*#__PURE__*/_jsx("ol", {
      className: styles.list,
      children: Array.isArray(instructions) && instructions.map(function (item, key) {
        if (item.instruction) {
          return /*#__PURE__*/_jsx(Text, {
            childrenInline: true,
            textElement: "li",
            typog: "bodycopyLarge",
            className: styles.listItem,
            "data-e2e-name": "instructions_food_list_item",
            children: item.instruction
          }, key);
        }
        return null;
      })
    });
  };
  if (loading) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.skeletonWrapper,
      children: [/*#__PURE__*/_jsx(SkeletonIndicator, {
        barWidths: ['80%', '90%', '73%', '100%', '62%'],
        size: "large"
      }), /*#__PURE__*/_jsx(SkeletonIndicator, {
        barWidths: ['80%', '65%', '73%', '46%', '62%'],
        className: styles.skeletonPadding,
        size: "large"
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles.instructionsFood,
    children: [/*#__PURE__*/_jsx(HeadingText, {
      className: styles.headline,
      align: "left",
      ariaLevel: 2,
      typog: "headline5",
      variant: "default",
      children: headline
    }), renderInstructions()]
  });
};